import { apiGet, API_URI, apiDownload } from "api";
import moment from "moment";
const report = {
    getminiofiles: async (boardId: number) => {
        const data = await apiGet(`${API_URI}/api/report/getminiofiles?boardId=${boardId}`);
        return data;
    },
    generate: async (boardId: number) => {
        const data = await apiGet(`${API_URI}/api/report?boardId=${boardId}`);
        return data;
    },
    downloadReport: async (filename: string) => {
        const data = await apiGet(`${API_URI}/api/report/reportfile?fileName=${filename}`);
        return data;
    },
    generateSalesReport: async (clientId: number) => {
        const data = await apiDownload(`${API_URI}/api/report/sales/${clientId}`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        return data;
    },
    generateBoardReport: async (boardId: number, dateFrom: Date, dateTo: Date) => {
        const data = await apiDownload(
            `${API_URI}/api/report/board?boardId=${boardId}&dateFrom=${moment(dateFrom).format("DD MMM YYYY")}&dateTo=${moment(dateTo).format("DD MMM YYYY")}`,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        return data;
    },
};

export default report;
